import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const EyeFill = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "18",
        height: "12",
        viewBox: "0 0 18 12",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.2252 5.58331C16.6919 4.65831 13.7586 0.016641 8.77522 0.166641C4.16689 0.283308 1.50022 4.33331 0.77522 5.58331C0.626359 5.84114 0.626359 6.15881 0.77522 6.41664C1.30022 7.32497 4.10855 11.8333 9.01689 11.8333H9.22522C13.8336 11.7166 16.5086 7.66664 17.2252 6.41664C17.3741 6.15881 17.3741 5.84114 17.2252 5.58331ZM9.00022 8.91664C7.38939 8.91664 6.08355 7.61081 6.08355 5.99997C6.08355 4.38914 7.38939 3.08331 9.00022 3.08331C10.6111 3.08331 11.9169 4.38914 11.9169 5.99997C11.9169 7.61081 10.6111 8.91664 9.00022 8.91664ZM9.88414 6.88382C10.3723 6.39567 10.3723 5.60421 9.88414 5.11606C9.39598 4.6279 8.60452 4.6279 8.11637 5.11606C7.62821 5.60422 7.62821 6.39567 8.11637 6.88382C8.60453 7.37198 9.39598 7.37198 9.88414 6.88382Z"
        })
    });
